/*eslint-disable*/ export const messages = JSON.parse("{\"page-indicator.aria.label\":[\"Prik \",[\"selectedPage\"],\" er fremhævet i en række med \",[\"pageCount\"],\" prikker\"]}");
//# sourceMappingURL=messages.mjs.map